import formatDate from 'legacy/utils/date/formatDate'

export function getHoursFromMilitaryTime(time: string): string {
  return time.substring(0, 2)
}

export function getMinutesFromMilitaryTime(time: string): string {
  return time.substring(2, 4)
}

export function getTimeFromMilitaryTime(time: string) {
  const hours = getHoursFromMilitaryTime(time)
  const minutes = getMinutesFromMilitaryTime(time)

  return {
    hours,
    minutes,
  }
}

export function dateTimeToMilitaryTime(date: Date) {
  return formatDate(date, 'HHmm')
}
